//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return {
            showRole: "Both",
        }
    },
    watch: {
        showRole(newRole) {
            this.$emit('changeRole', newRole)
        }
    },
    computed:{
        leadActive() {
      return {
        "text-man-100": this.showRole === "Lead",
      }
    },
    followActive() {
      return {
        "text-lady-100": this.showRole === "Follow",
      }
    },
    bothActive() {
      return {
        "text-indigo-500": this.showRole === "Both",
      }
    }
}
}
